import { render, staticRenderFns } from "./MarketReport.vue?vue&type=template&id=c97393be&scoped=true"
import script from "./MarketReport.vue?vue&type=script&lang=js"
export * from "./MarketReport.vue?vue&type=script&lang=js"
import style0 from "./MarketReport.vue?vue&type=style&index=0&id=c97393be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97393be",
  null
  
)

export default component.exports